import CityPageTemplate from "../city-template/CityPageTemplate";
import { eastonConfig } from "./data";

export default function EastonPage() {
  return <CityPageTemplate config={eastonConfig} />;
}